function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, useRef, useState } from "react";
import classNames from "classnames";
import { ALIGN_TYPES } from "constants/align-types";
import { withRouter } from "next/router";
import { isNodeFullyInView, scrollTo } from "/services/dom-utils-service";
import querystring from "querystring";
import { ACTIVE_TAB_ID } from "constants/query-params";
import useInterval from "client/services/hooks/use-interval";
import { StyledTabsComponent } from "./tabs-component.scss";
const TabsComponent = (props)=>{
    const { children, defaultActiveTabIndex, router, autoTransition, className, tabsAlign, scrollSpeed, scrollOnTabClick, distanceFromTop, onTabClick } = props;
    const getInitialActiveTabIndex = ()=>{
        try {
            var _router_asPath_split, _router_asPath;
            const params = querystring.parse(router === null || router === void 0 ? void 0 : (_router_asPath = router.asPath) === null || _router_asPath === void 0 ? void 0 : (_router_asPath_split = _router_asPath.split("?")) === null || _router_asPath_split === void 0 ? void 0 : _router_asPath_split[1]);
            const activeTabId = params === null || params === void 0 ? void 0 : params[ACTIVE_TAB_ID];
            if (activeTabId) {
                const activeTabIndexById = children === null || children === void 0 ? void 0 : children.findIndex((tab)=>{
                    var _tab_props;
                    return (tab === null || tab === void 0 ? void 0 : (_tab_props = tab.props) === null || _tab_props === void 0 ? void 0 : _tab_props.tabId) === activeTabId;
                });
                if (activeTabIndexById && activeTabIndexById >= 0) {
                    return activeTabIndexById;
                }
            }
        } catch (e) {
            return defaultActiveTabIndex;
        }
        return defaultActiveTabIndex;
    };
    const [activeTabIndex, setActiveTabIndex] = useState(getInitialActiveTabIndex());
    const contentNode = useRef();
    const autoTransitionAsNumber = Number(autoTransition || 0);
    useInterval(()=>{
        setActiveTabIndex((activeTabIndex + 1) % children.length);
    }, autoTransitionAsNumber > 0 ? autoTransitionAsNumber : null, [
        activeTabIndex
    ]);
    const handleTabClick = function() {
        var _ref = _async_to_generator(function*(index) {
            const node = contentNode === null || contentNode === void 0 ? void 0 : contentNode.current;
            if (onTabClick) {
                onTabClick(index);
            }
            try {
                if (scrollOnTabClick && node && !(yield isNodeFullyInView(node))) {
                    scrollTo(contentNode.current.offsetTop - distanceFromTop, scrollSpeed);
                }
            } catch (e) {}
            setActiveTabIndex(index);
        });
        return function handleTabClick(index) {
            return _ref.apply(this, arguments);
        };
    }();
    const tabsRenderer = ()=>{
        return children.map((child, index)=>{
            return /*#__PURE__*/ cloneElement(child, {
                onClick: handleTabClick,
                index,
                isActive: index === activeTabIndex
            });
        });
    };
    const contentRenderer = ()=>{
        if (children[activeTabIndex]) {
            return children[activeTabIndex].props.children;
        }
    };
    return /*#__PURE__*/ _jsxs(StyledTabsComponent, {
        className: classNames("tabs-component", className, tabsAlign),
        ref: contentNode,
        role: "tablist",
        "aria-label": "documentation-navigation",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "tabs",
                style: {
                    "--tab-transition": autoTransition
                },
                children: tabsRenderer()
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "content",
                role: "tab",
                children: contentRenderer()
            })
        ]
    });
};
export default withRouter(TabsComponent);
TabsComponent.defaultProps = {
    children: [],
    defaultActiveTabIndex: 0,
    autoTransition: "30000",
    scrollSpeed: 200,
    scrollOnTabClick: false,
    distanceFromTop: 0,
    className: "",
    tabsAlign: ALIGN_TYPES.CENTER
};
